import 'TweenLite';
import 'vendor/gsap/src/uncompressed/TimelineLite';
import 'vendor/gsap/src/uncompressed/plugins/CSSPlugin';
import 'vendor/gsap/src/uncompressed/plugins/ScrollToPlugin';

export default {
  TweenLite: window.TweenLite,
  TimelineLite: window.TimelineLite
};
